// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3-FZ7","modalForm":"UpgradeEpcsModal_modalForm__2rq5C","modalFooter":"UpgradeEpcsModal_modalFooter__1NLq3"};